import { Routes, Route } from "react-router-dom";
import ManagerSideMenu from "./components/sideMenu/SideMenu.jsx";
import EmployeesPage from "./pages/employeesPage/EmployeesPage.jsx";
import ClientsPage from "./pages/clientsPage/ClientsPage.jsx";
import ProjectsPage from "./pages/projectsPage/ProjectsPage.jsx";
import TasksPage from "./pages/tasksPage/TasksPage.jsx";
import MilestonesPage from "./pages/milestonesPage/MilestonesPage.jsx"; 
import AssignTask from "./pages/assignTask/AssignTask.jsx";
import ManagerHome from "./pages/homePage/ManagerHome.jsx";
import PaymentsPage from "./pages/paymentsPage/PaymentsPage.jsx"; 
import NotificationsPage from "./pages/notifications/NotificationsPage";

function ManagerLayout() {
  return (
    <div style={{ display: "flex" }}>
      <ManagerSideMenu />

      <div style={{ flex: 1, padding: "1rem" }}>
        <Routes>
          <Route index element={<ManagerHome />} />
          <Route path="dashboard" element={<ManagerHome />} />
          <Route path="employees" element={<EmployeesPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="reports" element={<h2>Reports</h2>} />
          <Route path="tasks" element={<TasksPage projectId={1} />} />
          <Route path="milestones" element={<MilestonesPage projectId={1} />} />
          <Route path="payments" element={<PaymentsPage />} /> 
          <Route path="notifications" element={<NotificationsPage />} />
          <Route
            path="assigntasks"
            element={<AssignTask projectId={1} />}
          />{" "}
          {/* ✅ existing route */}
        </Routes>
      </div>
    </div>
  );
}

export default ManagerLayout;
